<template>
  <div class="searchBox flex align-it-cen jus-con-bet" id="">
    <div class="flex align-it-cen left-action bg-white border-radius-5">
      <div class="flex align-it-cen mg-r-20 full-h">
        <div class="full-h">
          <a-dropdown :trigger="['click']">
            <div class="full-h pd-l-20 flex align-it-cen">{{ currentCity.city || currentCity.name || '成都' }}</div>
            <template #overlay><Citys @onSelect="onSelectCity" /> </template>
          </a-dropdown>
        </div>

        <div class="full-h">
          <a-dropdown :trigger="['click']">
            <div class="full-h pd-l-20 flex align-it-cen">{{ selectHouseType === '1' ? '租房' : '售房' }}</div>
            <template #overlay>
              <div class="pd-10 bg-white">
                <a-radio-group v-model="selectHouseType" @change="changeHouseType">
                  <a-radio-button v-for="(el, i) of houseType" :key="i" :value="el.value">
                    {{ el.label }}
                  </a-radio-button>
                </a-radio-group>
              </div>
            </template>
          </a-dropdown>
        </div>
      </div>
      <div class="flex align-it-cen">
        <a-input class="mg-r-10 input" id="tipinput" placeholder="关键字搜索">
          <a-icon slot="suffix" type="search" />
        </a-input>
        <!-- <a-icon  type="search" /> -->
      </div>
    </div>
    <div @click="search" class="btn-search bth-font-color btn-bg-color border-radius-10 flex align-it-cen jus-con-cen">POI搜索</div>
  </div>
</template>

<script>
import Citys from './citys.vue'
export default {
  components: {
    Citys,
  },
  props: {
    city: Object,
  },
  watch: {
    city: {
      handler() {
        this.currentCity = this.city
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      address: {}, // 选择地址
      currentCity: { name: '' }, // 选择城市
      // 租房售房类型
      houseType: [
        { label: '租房', value: '1' },
        { label: '售房', value: '2' },
      ],
      // 选择的租房还是售房
      selectHouseType: '1',
    }
  },
  methods: {
    // 房源类型变化
    changeHouseType() {
      console.log(this.selectHouseType, '00')
    },
    // 选择城市
    onSelectCity(it) {
      this.currentCity = it
    },
    // 注册筛选搜索
    registerSearch(AMap, map) {
      var auto = new AMap.AutoComplete({
        input: 'tipinput',
      })
      var placeSearch = new AMap.PlaceSearch({
        map,
      }) //构造地点查询类
      auto.on('select', select) //注册监听，当选中某条记录时会触发
      function select(e) {
        placeSearch.setCity(e.poi.adcode)
        placeSearch.search(e.poi.name) //关键字查询查询
        console.log(e,'map')
      }
    },
    search(){
      let points = []
      for(let i=0;i<100;i++){
        let random = Math.random() 
       points.push({
        weight: 1,
        lnglat: ['104.06' + i, '30.64' + i],
       })
      }
      console.log(points,'points')
      this.$emit('changeZoom',points)
    }
  },
}
</script>

<style lang="less" scoped>
.searchBox {
  width: 450px;
  position: absolute;
  left: 0px;
  top: 40px;
  background-color: transparent;
  height: 43px;
}
.left-action {
  //   padding: 10px 25px;
  height: 100%;
}
.btn-search {
  height: 100%;
  width: 105px;
}
/deep/ .ant-input {
  border: none !important;
  &:focus {
    border: none !important;
    outline: none !important;
    box-shadow: 0px 0px 3px rgba(0, 0, 0, 0) inset;
  }
}
</style>
